import React, { Fragment, useState } from "react";
import { Button } from "primereact/button";
import "../../../../template/App.css";
import { useEffect } from "react";
import { skillService } from "../../../../services/profile";
import { toast } from "react-toastify";
import { confirmDialog } from "primereact/confirmdialog";
import { Rating } from 'primereact/rating';

function PrimarySkill({ userPrimarySkills, onRefresh, profileUserId, userCommunicationSkillRating }) {
  const [overAllRating, setOverAllRating] = useState(0);
  useEffect(() => {
    if(profileUserId){
      getOverAllRating();
    }
  }, [userPrimarySkills,userCommunicationSkillRating]);

  const getOverAllRating = () => {
    let param = {
      id: profileUserId,
    }
    skillService.getOverAllRatings(param).then((resp) => {
      setOverAllRating(resp.data.data)
    });
  }

  const deleteSkillById = (id) => {
    confirmDialog({
      message: "Do you want to delete this record?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      acceptLabel: 'No',
      rejectLabel: 'Yes',
      accept: () => { },
      reject: () => updatePrimarySkillById(id),
    });
  };

  const updatePrimarySkillById = (id) => {
    let param = {
      id: id,
      primarySkills: false,
      primarySkillRating: 1,
      userId: profileUserId,
    };
    try {
      skillService.updateSkill(param).then((resp) => {
        onRefresh();
        toast.success("Primary Skill Deleted Succesfully")
      });
    } catch (error) {
      console.log(error);
    }
  };
  const updatePrimaryskillrating = (e, id) => {
    let param = {
      id: id,
      primarySkills: true,
      primarySkillRating: e.target.value,
      userId: profileUserId,
    };
    try {
      skillService.updateSkill(param).then((resp) => {
        onRefresh();
        toast.success("Skill Rating Updated")
      });
    } catch (error) {
      console.log(error);
    }
  }

  const updateCommunicationskillrating = (e, skillListData) => {
    let param = {
      communicationSkills: e.target.value,
      id: profileUserId
    };
    try {
      skillService.addCommunicationSkillsRatings(param).then((resp) => {
        onRefresh();
        toast.success("Skill Rating Updated")
      });
    } catch (error) {
      console.log(error);
    }
  };

  
  return (
    <>
      <Fragment>
        {userPrimarySkills && (
          <>
            <div className="wrapper p-3">
              <div className="grid">
                <div className="col">
                  <span className="heading">
                    Primary Skills
                  </span>
                </div>
              </div>
              <div className="align-items-center flex-wrap p-1">
                {userPrimarySkills.map((item, i) => (
                  <>
                    <div style={{ display: "inline-block", marginRight: '10px', alignItems: 'center' }}>
                      <Button key={"skillListData" + i} type="button" style={{ position: "inherit", marginBottom: "10px" }} className="p-button-rounded p-button-success mr-2">
                        <span style={{ marginleft: "60px", }}>{item?.Skill?.title}</span>
                        <i className="pi pi-times-circle" style={{ fontSize: "1.1rem", marginLeft: "10px", }} onClick={() => { deleteSkillById(item.id); }}
                        ></i>
                      </Button>
                      <div className="er" style={{ marginBottom: "25px" }}>
                        <Rating value={item.primarySkillRating} onChange={(e) => updatePrimaryskillrating(e, item.id)} />
                      </div>
                    </div>
                  </>
                ))}
              </div>
            </div>
          </>
        )}
      </Fragment>

      <Fragment>
        <>
          <div className="wrapper p-3 mt-2">
            <div className="grid">
              <div className="col">
                <span className="heading">
                  Communication Skill
                  <div><h5></h5></div>
                  <div>
                    <Rating value={userCommunicationSkillRating} onChange={(e) => updateCommunicationskillrating(e, userPrimarySkills)} />
                  </div>
                </span>
              </div>
            </div>
          </div>
        </>
      </Fragment>

      <Fragment>
        {userPrimarySkills && (
          <>
            <div className="wrapper p-3 mt-2">
              <div className="grid">
                <div className="col">
                  <span className="heading">
                    Overall Rating
                    <div><h5></h5></div>
                    <div>
                      <Rating value={overAllRating} />
                    </div>
                  </span>
                </div>
              </div>
            </div>
          </>
        )}
      </Fragment>
    </>
  );
}

export default PrimarySkill;